import PlusOutlined from '@ant-design/icons/PlusOutlined';
import App from 'antd/es/app';
import Button from 'antd/es/button';
import Empty from 'antd/es/empty';
import Modal from 'antd/es/modal';
import Typography from 'antd/es/typography';
import { useCallback, useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import ContentContainer from '@components/ContentContainer';
import CreateTaskForm from '@components/forms/CreateTaskForm/CreateTaskForm';
import TasksTable from '@components/tables/TasksTable';

const TaskListPage = () => {
  const { message } = App.useApp();
  const { teamId, projectId } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const createTaskModalOpen =
    searchParams.get('createTaskModalOpen') === 'true';

  const setCreateTaskModalOpen = useCallback(
    (open: boolean) => {
      setSearchParams(
        (prev) => {
          if (open) {
            prev.set('createTaskModalOpen', 'true');
          } else {
            prev.delete('createTaskModalOpen');
          }
          return prev;
        },
        {
          replace: true,
        },
      );
    },
    [setSearchParams],
  );

  if (!teamId || !projectId) {
    return (
      <Empty
        description="No team or project selected"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    );
  }

  return (
    <>
      <Modal
        open={createTaskModalOpen}
        onCancel={() => setCreateTaskModalOpen(false)}
        footer={null}
        width={isMobile ? '100%' : '1000px'}
        style={{ top: isMobile ? 0 : 100 }}
        bodyStyle={{
          height: isMobile ? '100vh' : 'auto',
          overflowY: isMobile ? 'auto' : 'visible',
        }}
      >
        <CreateTaskForm
          projectId={projectId}
          afterSubmit={() => {
            void message.success('Task created');
            setCreateTaskModalOpen(false);
          }}
        />
      </Modal>
      <ContentContainer showFullWidthToggle={false} forceFullWidth>
        <ContentContainer.Header
          title="Tasks"
          subtitle={
            <Typography.Text type="secondary">
              Stay organized with tasks, your way. Let our AI agents do the
              heavy lifting and get things done, today.
            </Typography.Text>
          }
          cta={
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => setCreateTaskModalOpen(true)}
            >
              Create Task
            </Button>
          }
        />
        <TasksTable projectId={projectId} />
      </ContentContainer>
    </>
  );
};

export default TaskListPage;
